import classnames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const SelectGroupContainer = styled.div`
  display: flex;

  &.show-label {
    margin-top: 1.75rem;

    .momos-select > label {
      display: block;
      position: absolute;
      left: 0;
      top: -1.5rem;
      font-weight: 600;
    }
  }

  .ant-select {
    position: relative;

    &::after {
      content: '|';
      position: absolute;
      right: 0;
      top: 0.5rem;
      font-weight: 300;
      font-size: 1.25rem;
      color: var(--grey);
    }
  }

  .ant-picker {
    position: relative;

    &::after {
      content: '|';
      position: absolute;
      right: 0;
      top: 0.5rem;
      font-weight: 300;
      font-size: 1.25rem;
      color: var(--grey);
    }
  }

  .momos-select {
    &:first-of-type {
      .ant-select-selector {
        border-top-left-radius: 30px !important;
        border-bottom-left-radius: 30px !important;
      }
      .ant-picker {
        border-top-right-radius: 30px !important;
        border-bottom-right-radius: 30px !important;
      }
    }
    &:last-of-type {
      .ant-select {
        &::after {
          content: '';
        }
      }
      .ant-select-selector {
        border-top-right-radius: 30px !important;
        border-bottom-right-radius: 30px !important;
      }
      .ant-picker {
        border-top-right-radius: 30px !important;
        border-bottom-right-radius: 30px !important;
      }
      .ant-picker {
        &::after {
          content: '';
        }
      }
    }
  }

  .ant-select-selector {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: 4px 0px 12px 0px rgb(0 0 0 / 7%) !important;
  }
  .ant-picker {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: 4px 0px 12px 0px rgb(0 0 0 / 7%) !important;
  }
`;

interface SelectGroupProps {
  children: React.ReactNode;
  className?: string;
  showLabel?: boolean;
}

const SelectGroup = ({ children, className, showLabel }: SelectGroupProps) => {
  return (
    <SelectGroupContainer className={classnames(className, { 'show-label': showLabel })}>
      {children}
    </SelectGroupContainer>
  );
};

export default SelectGroup;
